class TC_LazyLoad {
    constructor () {
        if ($('.k2-category-view .k2-item.is-loading').length) {
            this.init();
        }

        if ($('.k2-category-view .k2-blog-item.is-loading').length) {
            this.initBlogLazyLoad();
        }

        if ($('.k2-category-view .btn-load-more').length) {
            $('.k2-category-view .btn-load-more').on('click', this.loadMoreBlogItems.bind(this));
        }

        if ($('.k2-blog-items-search-wrapper').length) {
            this.initBlogSearch();
        }
    }

    init () {
        let items = $('.k2-category-view .k2-item.is-loading');

        items.each((i, item) => {
            item = $(item);
            let cover = item.find('.k2-item-img');
            let imgUrl = cover.attr('data-img');
            let img = $('<img src="' + imgUrl + '" />');
            img.on('load', () => {
                cover.css('background-image', 'url(\'' + imgUrl + '\')');
                img.remove();

                setTimeout(() => {
                    item.removeClass('is-loading');
                }, 100);
            });
            img.appendTo(cover);
        });
    }

    initBlogLazyLoad () {
        let items = $('.k2-category-view .k2-blog-item.is-loading').not('.is-hidden').not('.is-not-search-result');

        items.each((i, item) => {
            item = $(item);
            let cover = item.find('.k2-blog-item-img');
            let imgUrl = cover.attr('data-img');
            let img = $('<img src="' + imgUrl + '" />');
            img.on('load', () => {
                cover.css('background-image', 'url(\'' + imgUrl + '\')');
                img.remove();

                setTimeout(() => {
                    item.removeClass('is-loading');
                }, 100);
            });
            img.appendTo(cover);
        });
    }

    loadMoreBlogItems (e) {
        e.preventDefault();
        let items = $('.k2-category-view .k2-blog-item.is-hidden').not('.is-not-search-result');

        if (items.length) {
            for (let i = 0; i < 12; i++) {
                items.eq(i).addClass('to-show');

                setTimeout(() => {
                    items.eq(i).removeClass('is-hidden');
                }, 0);

                setTimeout(() => {
                    items.eq(i).removeClass('to-show');
                }, 50);
            }
        }

        setTimeout(() => {
            this.initBlogLazyLoad();

            if (!$('.k2-category-view .k2-blog-item.is-hidden').not('.is-not-search-result').length) {
                $('.k2-category-view .btn-load-more').addClass('is-hidden');
            }
        }, 500);
    }

    initBlogSearch () {
        let input = $('.k2-blog-items-search-wrapper input');
        let btn = $('.k2-blog-items-search-wrapper .btn');
        let items = $('.k2-category-view .k2-blog-item');

        input.on('search', (e) => {
            btn.trigger('click');
        });

        btn.on('click', () => {
            if (input.val() === '') {
                items.each((i, item) => {
                    $(item).removeClass('is-not-search-result');
                });
            } else {
                items.each((i, item) => {
                    if ($(item).attr('data-search').indexOf(input.val().trim()) > -1) {
                        $(item).removeClass('is-not-search-result');
                    } else {
                        $(item).addClass('is-not-search-result');
                    }
                });
            }

            let filteredItems = items.not('.is-not-search-result');
            console.log(filteredItems);


            for (let i = 0; i < filteredItems.length; i++) {
                if (i < 12) {
                    filteredItems.eq(i).removeClass('is-hidden');
                } else {
                    filteredItems.eq(i).addClass('is-hidden');
                }
            }

            if (filteredItems.length > 12) {
                $('.k2-category-view .btn-load-more').removeClass('is-hidden');
            } else {
                $('.k2-category-view .btn-load-more').addClass('is-hidden');
            }

            this.initBlogLazyLoad();
        });
    }
}
